import React from "react";
import type { FC, MouseEventHandler, ChangeEventHandler } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useShallowPickSelector } from "store/useSelector";
import { BottomSheet } from "components/atoms/BottomSheet";
import { appActions } from "store/app/app.slice";
import { FormControl, FormControlLabel, RadioGroup } from "@mui/material";
import { Radio } from "components/atoms/Radio";
import { currentUserActions } from "store/current-user/current-user.slice";
import type { Region } from "store/home/home.model";

export const RegionMenu: FC = () => {
  const { regionMenu } = useShallowPickSelector("app", ["regionMenu"]);
  const { region } = useShallowPickSelector("currentUser", ["region"]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const _location = useLocation();

  const onClose = () => {
    dispatch(appActions.setRegionMenu({ isOpen: false }));
  };

  const onChangeRegion: ChangeEventHandler<HTMLInputElement> = (event) => {
    let value: Region = event.target.value as Region;
    dispatch(currentUserActions.setRegion(value));
    onClose();
  };

  return (
    <BottomSheet
      title={"نمایش آهنگ‌ها"}
      isOpen={regionMenu.isOpen}
      onClose={onClose}
    >
      <FormControl>
        <RadioGroup
          aria-labelledby="نمایش آهنگ‌ها"
          defaultValue="all"
          name="region"
          value={region}
          onChange={onChangeRegion}
          sx={{
            mx: 4,
            mb: 2,
            "& > *": { marginTop: 1 },
            "& .MuiFormControlLabel-label": { fontSize: "0.875rem" },
            "& .MuiRadio-root + .MuiTypography-root": {
              opacity: 0.6,
            },
            "& .Mui-checked + .MuiTypography-root": {
              opacity: 1,
            },
          }}
        >
          <FormControlLabel
            value="all"
            control={<Radio />}
            label="ایرانی و خارجی"
            labelPlacement={"start"}
          />
          <FormControlLabel
            value="foreign"
            control={<Radio />}
            label="فقط خارجی"
            labelPlacement={"start"}
          />
          <FormControlLabel
            value="iranian"
            control={<Radio />}
            label="فقط ایرانی"
            labelPlacement={"start"}
          />
        </RadioGroup>
      </FormControl>
    </BottomSheet>
  );
};
